import { DashboardBreadcrumbs } from "~/ui-rtk/components/ui/common"
import AISummary from "./components/AISummary"
// import BrandPowerScore from "./components/BrandPowerScore"
import BrandComparison from "./components/BrandComparison"
import WithLoader from "~/ui-rtk/components/layout/WithLoader/WithLoader"
import AIModelTable from "./components/AIComparison/Table"
import { useMinMaxDateRange } from "~/ui-rtk/hooks/date-range"
import useDate from "~/ui-rtk/hooks/date"

const dayjs = useDate()
const maxDateRestriction = dayjs().toDate()

export default function HowAISeesYourBrandContainer() {
  const { dateRange } = useMinMaxDateRange(undefined, maxDateRestriction)

  return (
    <WithLoader isLoading={false}>
      <div className="flex flex-col px-system-md relative ">
        <div className="flex items-center justify-between gap-system-xs mb-system-2xl">
          <DashboardBreadcrumbs
            slug="brand-positioning-how-ai-sees-your-brand"
            title="How AI Sees Your Brand"
            parent={{ slug: "brand-positioning", title: "Brand Positioning" }}
          />
        </div>

        <AISummary />

        {/* <BrandPowerScore /> */}
        <BrandComparison dateRange={dateRange} maxDate={maxDateRestriction} />
        <AIModelTable dateRange={dateRange} />
      </div>
    </WithLoader>
  )
}
